const EVENT_NAMES = Object.freeze({
  MOUNTED: 'floating-elements:mounted',
});

const Events = {
  Mounted(managerInstance) {
    const event = new CustomEvent(EVENT_NAMES.MOUNTED, {
      detail: managerInstance,
    });

    return event;
  },
};

export { EVENT_NAMES, Events };
